<div class="file-upload" *ngIf="_uploader">

  <div class="form-group row file-display-container">
    <div class="col-12 uploader-label" *ngIf="label">
      <label>{{label}}</label>
    </div>
    <div placement="top"
        triggers="mouseenter:mouseleave"
        ngbPopover="{{popoverMessage}}"
        popoverTitle=""
        class="col-12 col-sm-12 col-md-12 col-lg-4 file-displayer">
          <label class="file-display">{{_uploader?.fileName || label}}</label>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-4 file-button">
      <label for="{{fileUploadId}}" i18n="@@UPLOADER-FIELD-001">Browse file</label>
      <input
        class="file-upload-element"
        id="{{fileUploadId}}"
        type="file"
        ng2FileSelect
        [uploader]="_uploader.uploader"
        (change)="selectFile($event)"
        [accept]="iconFileOptions.types"/>
    </div>

  </div>
  <span class="message-error" *ngIf="componentMessage.value">{{componentMessage.value}}</span>
</div>
